/**
 * User preference save helpers.
 *
 * Batches same-action preference updates through the bulk endpoint while
 * keeping the optimistic Redux/session behavior used by preference hooks.
 */

function receiveUserPreferences(payload) {
  return { type: 'userPreferences/receiveUserPreferences', payload };
}

function upsertUserPreferenceLocal(payload) {
  return { type: 'userPreferences/upsertUserPreferenceLocal', payload };
}

function normalizePreferenceItems(items = []) {
  return items.filter(item => item?.key).map(item => ({ key: item.key, value: item.value }));
}

function writeSessionPreference(storage, key, value) {
  if (!storage) return;
  try {
    storage.setItem(`pref:${key}`, JSON.stringify(value));
  } catch {
    // ignore
  }
}

export async function saveUserPreferenceItems({
  dispatch,
  items,
  persist,
  optimistic = true,
  storage = typeof sessionStorage === 'undefined' ? null : sessionStorage,
}) {
  const saveItems = normalizePreferenceItems(items);
  if (saveItems.length === 0) return [];

  if (optimistic) {
    saveItems.forEach(item => {
      writeSessionPreference(storage, item.key, item.value);
      dispatch(upsertUserPreferenceLocal(item));
    });
  }

  if (!persist) return [];

  try {
    const records = await persist(saveItems);
    dispatch(receiveUserPreferences(records));
    return records;
  } catch {
    return [];
  }
}
